import { FC, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Tooltip } from 'bootstrap'
import { KTIcon } from '../../../../../../../_metronic/helpers'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { approveJob } from '../../../_requests'

type Props = {
  id: string
  status: string
  approval_status?: string
}

const JobActionsCell: FC<Props> = ({ id, status, approval_status }) => {
  const { refetch } = useQueryResponse()

  useEffect(() => {
    const tooltipTriggerList = Array.from(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    ) as HTMLElement[]

    const instances = tooltipTriggerList.map((el) => new Tooltip(el))

    return () => {
      instances.forEach((i) => i.dispose())
    }
  }, [])

  const normalizedApprovalStatus = approval_status?.toString().toLowerCase()

  const approveRejectJobFun = (type: string) => {
    approveJobFun(type)
  }

  const approveJobFun = async (type: string) => {
    try {
      await approveJob({ job_id: id, action: type })
      toast.success(`The job has been ${type === 'Approved' ? 'approved' : 'rejected'} successfully.`)
      // refetch the job list so the updated approval_status shows in the table
      refetch()
    } catch (err: any) {
      const msg = err?.response?.data?.message || err?.message || 'Failed to process job'
      toast.error(msg)
    }
  }

  return (
    <>
      <div className='d-flex justify-content-center flex-shrink-0 gap-3'>
        <Link
          to={`/jobs/edit/${id}`}
          data-bs-toggle='tooltip'
          data-bs-placement='top'
          title='Edit Job'
          aria-label='Edit Job'
          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm btn-sm-theme rounded-circle border border-dashed'
        >
          <KTIcon iconName='pencil' className='fs-3' />
        </Link>

        {normalizedApprovalStatus === 'pending' && (
          <>
            <button
              onClick={() => approveRejectJobFun('Rejected')}
              data-bs-toggle='tooltip'
              data-bs-placement='top'
              title='Reject Job'
              aria-label='Reject Job'
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm btn-sm-theme rounded-circle border border-dashed'
            >
              <KTIcon iconName='abstract-11' className='fs-3' />
            </button>
            <button
              onClick={() => approveRejectJobFun('Approved')}
              data-bs-toggle='tooltip'
              data-bs-placement='top'
              title='Approve Job'
              aria-label='Approve Job'
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm btn-sm-theme rounded-circle border border-dashed'
            >
              <KTIcon iconName='double-check' className='fs-3' />
            </button>
          </>
        )}
        {normalizedApprovalStatus === 'approved' && (
          <button
            onClick={() => approveRejectJobFun('Rejected')}
            data-bs-toggle='tooltip'
            data-bs-placement='top'
            title='Reject Job'
            aria-label='Reject Job'
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm btn-sm-theme rounded-circle border border-dashed'
          >
            <KTIcon iconName='abstract-11' className='fs-3' />
          </button>
        )}
        {normalizedApprovalStatus === 'rejected' && (
          <button
            onClick={() => approveRejectJobFun('Approved')}
            data-bs-toggle='tooltip'
            data-bs-placement='top'
            title='Approve Job'
            aria-label='Approve Job'
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm btn-sm-theme rounded-circle border border-dashed'
          >
            <KTIcon iconName='double-check' className='fs-3' />
          </button>
        )}
      </div>
    </>
  )
}

export { JobActionsCell }
